export enum PageTitle {
  UserList = 'Users',
  UserDetail = 'User Detail',
  Documents = 'Documents',
}
